import styled from 'styled-components'

import { theme } from 'styles/theme'

const { media, space, colors } = theme

export const Title = styled.div`
  padding-bottom: 0;

  @media (${media.tablet}) {
    h2,
    span {
      font-size: 3.5rem;
    }
  }
`

export const ItemList = styled.div`
  padding-top: ${space['spacing-lg']};
`

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media (${media.desktop}) {
    display: grid;
    grid-template-rows: repeat(3, 1fr);
    grid-template-columns: repeat(3, 1fr);
    height: 100%;
  }
`

export const Card = styled.div`
  border: solid ${colors['neutral-text-weak']} 1px;
  padding: ${space['spacing-sm']};
  border-radius: ${space['spacing-xs']};
  width: 100%;
  display: flex;
  flex-direction: column;

  h3 {
    margin: ${space['spacing-sm']} 0 ${space['spacing-md']};
    font-size: 1.188rem;
  }

  a {
    display: inline-block;
    color: ${colors['neutral-text-weak']};

    &::after {
      color: ${colors['neutral-text-weak']};
    }
  }
`

export const CarouselItem = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  border: solid ${colors['neutral-text-weak']} 1px;
  border-radius: ${space['spacing-xs']};
  padding: ${space['spacing-sm']};
  overflow: hidden;
  cursor: grab;

  h3 {
    margin: ${space['spacing-sm']} 0;
    font-size: 1.188rem;
  }

  a {
    color: ${colors['neutral-text-weak']};
    font-size: inherit !important;

    &::after {
      color: ${colors['neutral-text-weak']};
    }
  }
`

export const IconImage = styled.div`
  width: 55px;
`
